export default __webpack_public_path__ + "static/media/zigzag.f67aa812.svg";